import { Component, OnInit, Input } from '@angular/core';
import { FindInspectionService } from '../../services/find-inspection.service';
import { InspectionRowViewModel, EqAndInspectionIds } from '../../models/find-inspection.model';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';


@Component({
  selector: 'app-temperature-list-row',
  templateUrl: './temperature-list-row.component.html',
  styleUrls: ['./temperature-list-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class TemperatureListRowComponent implements OnInit {

  //@Input() inspectionId: number;
  @Input() EQnInspectionIds : EqAndInspectionIds;
  public inspection: InspectionRowViewModel;
  public loadingRow: boolean = true;

  constructor(private _findInspection: FindInspectionService,
    private _router: Router) { }

  ngOnInit() {
    this.loadRowData();
  }

  getEval(val:boolean){
    if(val== true)
    return "major"
    if(val== false)
    return "minor"
    if(val== null)
    return "none"
  }
  loadRowData() {
    this._findInspection.getTemperatureInspectionRow(this.EQnInspectionIds.InspectionId).subscribe(r => {
      this.inspection = r;
      this.loadingRow = false;
    });
  }

  openInspection() {
    // this._router.navigate(['tempinspection', this.EQnInspectionIds.EquipmentId , this.EQnInspectionIds.InspectionId]);
    window.open('/tempinspection/' + this.EQnInspectionIds.EquipmentId + '/' + this.EQnInspectionIds.InspectionId, '_blank');
  }


}
